import React from "react";
import { Snackbar, Alert } from "@mui/material";

export const FormSnackbar = ({ snackbar, onClose }) => (
  <Snackbar
    open={snackbar.open}
    autoHideDuration={5000}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
  >
    <Alert
      severity={snackbar.severity}
      variant="filled"
      onClose={onClose}
      sx={{ borderRadius: 2 }}
    >
      {snackbar.message}
    </Alert>
  </Snackbar>
);
